import useLayout from 'hooks/useLayout';
import {FC, useRef} from 'react';

type LayoutContentProps = {
    children: JSX.Element;
};

const LayoutContent: FC<LayoutContentProps> = ({children}) => {
    const ref = useRef(null);
    const layout = useLayout(ref);

    if (!layout) return <div className="hidden" ref={ref} />;

    if (layout !== 'sideBySide') {
        return children;
    }

    return (
        <>
            <div>&nbsp;</div>
            <div ref={ref} role="gridcell">
                {children}
            </div>
        </>
    );
};
export default LayoutContent;
